import React, { useState, useEffect } from "react";
import "./Utils.scss";
import { Link } from "react-router-dom";
import Slider from "react-slick";

import loader from "../../Resources/images/shapes/loader.gif";

export const mapServices = (services) => {
  return services.map((service, index) => {
    const loaded = useProgressiveImage(service.image);

    return (
      <div className="col-12 col-sm-10 col-md-6 service-item" key={index}>
        <div
          className="service-content"
          style={{ backgroundImage: `url(${loaded || loader})` }}
        >
          {service.title ? (
            <Link to={service.destination}>
              <div className="hover-content transition-3">
                <div className="title">
                  {service.destination ? (
                    <>
                      <h2>{service.title}</h2>
                      {service.location ? <p>{service.location}</p> : null}
                    </>
                  ) : (
                    <>
                      <h2>{service.title}</h2>
                      {service.location ? <p>{service.location}</p> : null}
                    </>
                  )}
                </div>
              </div>
            </Link>
          ) : null}
        </div>
      </div>
    );
  });
};

const useProgressiveImage = (src) => {
  const [sourceLoaded, setSourceLoaded] = useState(null);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => setSourceLoaded(src);
  }, [src]);

  return sourceLoaded;
};


export const mapPageNav = (links, pathname) => {
  return links.map((link, index) => {
    return (
      <div className="col nav-item no-side-padding" key={index}>
        <Link to={link.destination}>
          <button className={link.destination === pathname ? "active text-blue" : "text-blue"}>
            {link.title}
            <hr className="transition-3" />
          </button>
        </Link>
      </div>
    );
  });
};

export const mapStyles = (styles) => {
  return styles.map((style, index) => {
    return (
      <div className="col-12 col-md-5 col-lg-4 style-item" key={index}>
        <div
          className="image"
          style={{ backgroundImage: `url(${style.image})` }}
        >
          {/* <Link to={style.destination}>
            <div className="cta">Learn More</div>
          </Link> */}
        </div>

        <div className="title">
          <p>{style.title}</p>
        </div>
      </div>
    );
  });
};


export const mapGallery = (arr, title, setShowModal, setCurrent) => {
  return arr.map((item, index) => {
    return (
      <div
        className="col-12 col-sm-6 col-md-4 col-xl-3 gallery-item transition-3"
        key={index}
        style={{ backgroundImage: `url(${item.image})` }}
        onClick={() => {
          setCurrent(index);
          setTimeout(() => {
            setShowModal(true);
          }, 300);
        }}
        aria-label={item.aria}
      >
        <div className="row description-container align-self-center transition-3">
          <div className="col my-auto">
            <p>{item.description}</p>
          </div>
        </div>
      </div>
    );
  });
};


export const mapPageNavMobile = (links, pathname, sliderRef, history) => {
  const settings = {
    focusOnSelect: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    speed: 500,
    beforeChange: (current, next) => nextPage(next),
  };

  const nextPage = (next) => {
    const destination = links[next].destination;
    history.push(destination);
  };

  const mapNav = () => {
    return links.map((link, index) => {
      return (
        <div className="nav-item mb-2 no-side-padding" key={index}>
          <Link to={link.destination}>
            <button className={link.destination === pathname ? "active" : ""}>
              {link.title}
              <hr className="transition-3" />
            </button>
          </Link>
        </div>
      );
    });
  };

  return (
    <Slider {...settings} ref={sliderRef}>
      {mapNav()}
    </Slider>
  );
};